import React from 'react'
import { Button } from 'antd'
import styles from './style.module.scss'

const Footer = () => (
  <div className={styles.footer}>
    <div className={styles.inner}>
      <div className="row">
        <div className="col-lg-9">
          <p>
            <strong>Plain4 - Plataforma Industria 4.0</strong>
          </p>
          <p>
            Es un desarrollo progresivo de herramientas para comunicaciones con dispositivos
            industriales que le permitiran entrar al nuevo estandard tecnol&oacute;gico llamado
            &quot;Industria 4.0&quot;.
          </p>
          <p>
            We develop tools for adapt industrial devices with the new standard &quot;Industry
            4.0&quot;.
          </p>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className="row">
          <div className="col-sm-6">
            <a
              href="http://www.plain4.com"
              target="_blank"
              rel="noopener noreferrer"
              className="mr-4"
            >
              <Button type="danger">Información</Button>
            </a>
          </div>
          <div className="col-sm-6">
            <div className={styles.copyright}>
              <img
                src="/resources/images/fortesitio.png"
                rel="noopener noreferrer"
                alt="ForteSitio Software"
              />
              <span>
                © 2020{' '}
                <a href="http://www.fortesitio.com/" target="_blank" rel="noopener noreferrer">
                  ForteSitio
                </a>
                <br />
                All rights reserved Derechos Reservados
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Footer
